import React from 'react'
import { AttachmentLink } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { Block, BlockRow, Text } from '@pandiafi/components'

import { Section } from '../../../components'
import { FeedbackAndQuestionNoticeDetails } from '../../../../common/validations/feedbackAndQuestionNotice'
import { User } from '../../../../common/validations'

import { CardTitleBand } from 'components/CardTitleBand/CardTitleBand'

interface FeedbackViewProps {
  existingNotice?: FeedbackAndQuestionNoticeDetails
  user?: User
}

export const FeedbackDetailView: React.FC<FeedbackViewProps> = ({
  existingNotice,
  user,
}) => {
  const { t } = useTranslation(['common', 'feedback'])

  const { title, description, files } = existingNotice || {}

  return (
    <>
      <CardTitleBand>{t('feedback:headings.feedbackDetail')}</CardTitleBand>
      <Section className="mb-12">
        <Block>
          {user && (
            <BlockRow>
              <Text element="p">{user.email}</Text>
              <Text element="p">{user.phoneNumber}</Text>
            </BlockRow>
          )}
          <BlockRow>
            <Text element="h2" size="xl" weight="medium">
              {title}
            </Text>
          </BlockRow>
          <BlockRow>
            <Text element="p" className="hyphens-auto [overflow-wrap:anywhere]">
              {description}
            </Text>
          </BlockRow>
          {files && files.length > 0 && (
            <>
              <BlockRow>
                <Text element="h3" size="m" weight="medium">
                  {t('feedback:labels.files')}:
                </Text>
              </BlockRow>
              {files.map((file) => (
                <BlockRow key={file.uuid || file.fileName}>
                  <AttachmentLink
                    text={file.fileName || `${t('common:file')}`}
                    icon="paperclip"
                    disabled
                  />
                </BlockRow>
              ))}
            </>
          )}
        </Block>
      </Section>
    </>
  )
}
